import React from "react";
import { motion } from "framer-motion";
import { Shield, HardDrive, Server, Timer, LifeBuoy, Layers } from "lucide-react";

const FEATURES = [
  { icon: Shield, title: "Anti-DDoS Empresarial", description: "Protección perimetral L3/L4/L7 con mitigación en tiempo real." },
  { icon: HardDrive, title: "Almacenamiento NVMe", description: "I/O extrema con SSDs NVMe Gen4 para velocidad máxima." },
  { icon: Server, title: "Panel Pterodactyl", description: "Gestión total: consola, archivos, backups y subusuarios." },
  { icon: Layers, title: "Backups Automáticos", description: "Snapshots programados para que nunca pierdas progreso." },
  { icon: Timer, title: "Despliegue Instantáneo", description: "Tu servidor listo en segundos, no en horas." },
  { icon: LifeBuoy, title: "Soporte 24/7", description: "Equipo técnico siempre disponible vía ticket y Discord." },
];

export const FeaturesStrip = () => {
  return (
    <section className="relative py-16 sm:py-20" data-testid="features-strip">
      <div className="osx-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl mb-10"
        >
          <div className="text-xs font-mono uppercase tracking-[0.25em] mb-3" style={{ color: "var(--osx-brand-600)" }}>
            Infraestructura
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight" style={{ color: "var(--osx-text)" }}>
            Todo lo que tu servidor necesita, <span className="osx-gradient-text">incluido desde el día 1</span>.
          </h2>
        </motion.div>

        <div className="grid gap-4 sm:gap-5 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((f, idx) => (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: idx * 0.05 }}
              whileHover={{ y: -4 }}
              className="relative p-6 rounded-2xl osx-gradient-border"
              style={{
                background: "var(--osx-surface)",
                border: "1px solid var(--osx-border)",
                boxShadow: "var(--osx-shadow-1)",
                transition: "box-shadow 0.3s ease, border-color 0.3s ease",
              }}
              data-testid={`feature-card-${idx}`}
            >
              <div
                className="inline-flex h-11 w-11 items-center justify-center rounded-xl mb-4"
                style={{
                  background: "color-mix(in oklab, var(--osx-brand-600) 15%, var(--osx-surface-2))",
                  color: "var(--osx-brand-600)",
                  border: "1px solid var(--osx-border-strong)",
                }}
              >
                <f.icon size={18} strokeWidth={2.2} />
              </div>
              <h3 className="text-base sm:text-lg font-semibold mb-1.5" style={{ color: "var(--osx-text)" }}>
                {f.title}
              </h3>
              <p className="text-sm leading-relaxed" style={{ color: "var(--osx-text-muted)" }}>
                {f.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
